import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { getServiceData } from "./ServiceData";
import "./Services.css";
import { useLocale } from "../context/LocaleContext";

const Services = () => {
  const { locale, t } = useLocale();
  const serviceData = useMemo(() => getServiceData(locale), [locale]);

  return (
    <>
      <section id="our-services">
        <div className="services_container">
          <h2 className="services_header">
            <span>
              <i className="fa-solid fa-angles-right" aria-hidden="true"></i>
            </span>
            {t("services.header")}
          </h2>
          <div className="service_info_container">
            {serviceData.map((item) => (
              <Link
                key={item.pageId}
                to={item.to}
                className="service_info service_info--link"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <img
                  className={`service_image_details${
                    item.imageIsPhoto ? ' service_image_details--photo' : ''
                  }${item.pageId === 'miniImplants' ? ' service_image_details--micro' : ''}`}
                  src={item.img_src}
                  alt={item.title}
                />
                <h2 className="service__title">{item.title}</h2>
                <p className="service_detail_info">{item.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
